var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJobRole(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 27,
    height: 27,
    rx: 13.5,
    fill: "#F9FAFB"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 27,
    height: 27,
    rx: 13.5,
    stroke: "#EAECF0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.3334 20C19.3334 19.0696 19.3334 18.6044 19.2186 18.2259C18.9601 17.3736 18.2931 16.7067 17.4408 16.4482C17.0623 16.3333 16.5971 16.3333 15.6667 16.3333H12.3334C11.403 16.3333 10.9379 16.3333 10.5593 16.4482C9.70705 16.7067 9.04011 17.3736 8.78157 18.2259C8.66675 18.6044 8.66675 19.0696 8.66675 20M17.0001 11C17.0001 12.6569 15.6569 14 14.0001 14C12.3432 14 11.0001 12.6569 11.0001 11C11.0001 9.34315 12.3432 8 14.0001 8C15.6569 8 17.0001 9.34315 17.0001 11Z",
    stroke: "#667085",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJobRole);
export default __webpack_public_path__ + "static/media/job-role.a0919ac340dfd3e236fa95eb484ff094.svg";
export { ForwardRef as ReactComponent };